import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DID } from 'voxloud-types/dist/models';

import { PortabilityDocuments } from 'src/app/shared/portability.models';
import { environment } from 'src/environments/environment';
import { PortabilityRequestResponse, DID_PORTABILITY_STATUS } from '../models';

@Injectable()
export class PortabilityService {
  constructor(private http: HttpClient) { }

  public sendPortabilityRequest(payload: FormData): Observable<PortabilityRequestResponse> {
    return this.http.post<PortabilityRequestResponse>(`${environment.apiEndpoint}/api/v1/portabilities/requests`, payload);
  }

  public buildPortabilityData(companyId: number, did: DID, files: PortabilityDocuments): FormData {
    const payload = {
      company_id: companyId,
      status: DID_PORTABILITY_STATUS.COMPLETED,
      did_ids: [did.id]
    };
    const formData = new FormData();
    formData.append('last_invoice', files.invoice);
    formData.append('portability_template_signed', files.module);
    const blobDids = new Blob([JSON.stringify(payload)], { type: 'application/json' });
    formData.append('request', blobDids);
    switch (did.country) {
      case 'US':
      case 'GB':
        formData.append('identity', null);
        break;
      case 'IT': {
        formData.append('identity', files.identity);
      }
        break;
    }
    return formData;
  }
}
